import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import VideoGallery from "@/pages/VideoGallery";
import {
  galleryVideos,
  videoEmbedUrl,
  videoThumbnail,
  videoUploadDate,
  videoWatchUrl,
} from "@/data/galleryVideos";

const PAGE_URL = "https://www.rexandsonsrvs.com/video-gallery";

const videoSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Rex & Sons RVs Video Gallery",
  url: PAGE_URL,
  itemListElement: galleryVideos.map((v, i) => ({
    "@type": "ListItem",
    position: i + 1,
    item: {
      "@type": "VideoObject",
      name: v.title,
      description: v.description,
      thumbnailUrl: videoThumbnail(v.id),
      uploadDate: videoUploadDate(v.date),
      contentUrl: videoWatchUrl(v.id),
      embedUrl: videoEmbedUrl(v.id),
      publisher: { "@type": "Organization", name: "Rex & Sons RVs", url: "https://www.rexandsonsrvs.com" },
    },
  })),
};

export const Route = createFileRoute("/video-gallery")({
  head: () => ({
    ...pageHead({
      title: "RV Video Gallery",
      description: "Watch walkthroughs, tips and feature videos from Rex & Sons RVs — tour new and used RVs before you visit our Castle Hayne, NC dealership.",
      path: "/video-gallery",
    }),
    scripts: [{ type: "application/ld+json", children: JSON.stringify(videoSchema) }],
  }),
  component: VideoGallery,
});
